angular.module('trainerWebApp.resources')
  .factory('arrangeResource', ['$resource', '$window', 'errorHandler', 'mtypes', function ($resource, $window, errorHandler, mtypes) {

    var ArrangeResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId/:type');
    var PreviewResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/preview');
    var CourseSeriesMicroServiceResource = $resource(mfConfig.courseSeriesBaseUrlSegment + '/series/:seriesId/course');

    ArrangeResource.prototype.getSeriesInfo = function getSeriesInfo(seriesId, resultCb, errorCb) {
      return ArrangeResource.get({
        seriesId: seriesId,
        type: 'series-setup'
      }, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    ArrangeResource.prototype.getSeriesPreviewInfo = function getSeriesPreviewInfo(resultCb, errorCb) {
      return PreviewResource.get({}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    ArrangeResource.prototype.updateSeriesDetails = function updateSeriesDetails(data, resultCb, errorCb) {
      return ArrangeResource.save({
        seriesId: data.seriesId,
        type: 'details'
      }, data, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    ArrangeResource.prototype.updateSeriesCourses = function updateSeriesCourses(data, resultCb, errorCb) {
      var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);

      if(hasNewSeriesFeature) {
        return CourseSeriesMicroServiceResource.save({
          seriesId: data.seriesId
        }, data, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
      }

      return ArrangeResource.save({
        seriesId: data.seriesId,
        type: 'course'
      }, data, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    ArrangeResource.prototype.getCourseTitle = function getCourseTitle(id, resultCb, errorCb) {
      return $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/:type').get({
        courseId: id,
        type: 'title'
      }, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new ArrangeResource;
  }]);
